import { getCommonAnalytics } from '../common-analytics';

declare global {
  interface Window {
    _wq?: any[];
  }
}

export function registerWistiaAnalytics(): void {
  window._wq = window._wq || [];
  if (window._wq.length === 0) {
    window._wq.push({
      id: '_all',
      onReady(video: any) {
        const videoAnalytics = (videoEventName: string) => {
          const data = {
            'video-type': 'Wistia',
            comp: 'wistiavideo',
            'video-complete-percentage': Math.ceil(video.percentWatched() * 100),
            'video-id': video.data.media.hashedId,
            'video-name': video.data.media.name,
            ...getCommonAnalytics(video.container),
          };
          window.Mhecomm?.emit(videoEventName, data, {}, video.container);
        };
        video.bind('play', () => {
          videoAnalytics('video-play');
        });
        video.bind('pause', () => {
          videoAnalytics('video-pause');
        });
        video.bind('end', () => {
          videoAnalytics('video-completed');
        });
        video.bind('popoverhide', () => {
          videoAnalytics('video-closed');
        });
        video.bind('percentwatchedchanged', (percent: number, lastPercent: number) => {
          if (
            (percent >= 0.25 && lastPercent < 0.25) ||
            (percent >= 0.5 && lastPercent < 0.5) ||
            (percent >= 0.75 && lastPercent < 0.75)
          ) {
            videoAnalytics('video-progress');
          }
        });
      },
    });
  }
}
